interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schema }: SEOHeadProps) {
  const fullTitle = `${title} | 黑料六点半`;
  const baseUrl = 'https://www.heilia630.com';

  const metaTags = {
    title: fullTitle,
    description,
    keywords,
    canonical: `${baseUrl}${canonicalUrl}`,
    ogTitle: fullTitle,
    ogDescription: description,
    ogType,
    ogUrl: `${baseUrl}${canonicalUrl}`,
    ogImage: ogImage || `${baseUrl}/og-default.jpg`,
    twitterCard: 'summary_large_image',
    twitterTitle: fullTitle,
    twitterDescription: description,
    twitterImage: ogImage || `${baseUrl}/og-default.jpg`,
  };

  return (
    <>
      <title>{metaTags.title}</title>
      <meta name="description" content={metaTags.description} />
      <meta name="keywords" content={metaTags.keywords} />
      <link rel="canonical" href={metaTags.canonical} />

      <meta property="og:title" content={metaTags.ogTitle} />
      <meta property="og:description" content={metaTags.ogDescription} />
      <meta property="og:type" content={metaTags.ogType} />
      <meta property="og:url" content={metaTags.ogUrl} />
      <meta property="og:image" content={metaTags.ogImage} />
      <meta property="og:site_name" content="黑料六点半" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content={metaTags.twitterCard} />
      <meta name="twitter:title" content={metaTags.twitterTitle} />
      <meta name="twitter:description" content={metaTags.twitterDescription} />
      <meta name="twitter:image" content={metaTags.twitterImage} />

      {schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      )}
    </>
  );
}